import { breadcrumb } from './breadcrumb';

export const referral = {
  breadcrumb,

  description:
    'You can receive bonuses for your customers. For each new user who registered using your link, you will receive up to {percent}% of their expenses.',

  button: {
    create_request: 'Withdraw funds'
  },

  user: {
    field: {
      email: 'Email',
      created_at: 'Registration Date'
    }
  },

  profit: {
    field: {
      date_from: 'Start period',
      date_to: 'End period',
      referral: 'Referral',
      amount: 'Amount'
    }
  },

  request: {
    type: {
      internal: 'Zorra balance',
      external: 'Withdraw funds'
    },

    status: {
      pending: 'Pending',
      success: 'Success',
      rejected: 'Rejected',
      failed: 'Failed'
    },

    field: {
      amount: 'Amount'
    },

    modal: {
      create: {
        content:
          'Your balance {balance}. You can replenish your Zorra balance or create a request for withdrawal of money.'
      }
    }
  }
};
